import styled from '@emotion/styled'
import {theme} from '../../../../accountManagement/theme'

export const CardWrapper = styled.div`
  background: ${theme.colors.bg.primary};
  border-radius: ${theme.radii.lg2};
  padding: ${theme.space[3]};
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2.5]};
  cursor: pointer;
  opacity: ${({isDimmed}) => (isDimmed ? 0.4 : 1)};
  transition: box-shadow ${theme.transitions.fast},
    opacity ${theme.transitions.normal};
  box-shadow: ${({isSelected}) =>
    isSelected
      ? `inset 0 0 0 1px ${theme.colors.action.primary}, 0px 4px 4px 0px #00000021`
      : 'none'};

  &:hover {
    box-shadow: inset 0 0 0 1px ${theme.colors.action.primary},
      0px 4px 4px 0px #00000021;
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[3]};
`

export const CardIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: ${theme.radii.md};
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CardIconImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const CardName = styled.span`
  flex: 1;
  font-family: ${theme.fonts.openSans};
  font-size: clamp(0.7292rem, 0.6629rem + 0.2652vi, 0.875rem);
  font-weight: ${theme.fontWeights.bold};
  line-height: 1;
  color: ${theme.colors.text.primary};
`

export const CardDescription = styled.p`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  line-height: 1.4;
  color: ${theme.colors.text.primary};
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({hasPrice}) => (hasPrice ? 'space-between' : 'flex-end')};
  margin-top: ${theme.space[1]};
  gap: ${theme.space[1]};
`

export const CardPrice = styled.span`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.base};
  font-weight: ${theme.fontWeights.bold};
  line-height: 1;
  color: ${theme.colors.text.primary};

  span {
    font-family: ${theme.fonts.openSans};
    font-size: ${theme.fontSizes.xs};
    font-weight: ${theme.fontWeights.bold};
    line-height: 1;
    color: ${theme.palette.neutral[300]};
  }
`

export const ArrowWrapper = styled.span`
  display: flex;
  align-items: center;
  transition: transform ${theme.transitions.normal};
  transform: ${({isExpanded}) =>
    isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`

export const CardAction = styled.button`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.bold};
  line-height: 1;
  color: ${theme.colors.action.primary};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: ${theme.space[1.5]};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
